import { render, staticRenderFns } from "./BuyRatioItem.vue?vue&type=template&id=4dcbded8&scoped=true&"
import script from "./BuyRatioItem.vue?vue&type=script&lang=js&"
export * from "./BuyRatioItem.vue?vue&type=script&lang=js&"
import style0 from "./BuyRatioItem.vue?vue&type=style&index=0&id=4dcbded8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbded8",
  null
  
)

export default component.exports